export default function AboutBrand() {
  return (
    <section className="relative w-full py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300/40 font-label text-xs font-medium text-foreground-600 mb-6">
          Co to jest Kakobuy Spreadsheet?
        </span>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-snug mb-8">
          Dlaczego użytkownicy wybierają
          <br />
          <span className="text-accent-600">Kakobuy Spreadsheet</span>?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mt-12">
          <div className="text-left space-y-5">
            <p className="font-heading text-xl font-semibold text-foreground-800 mb-4">Bez Spreadsheet:</p>
            {[
              'Trudne znalezienie produktów',
              'Brak porównania jakości i cen',
              'Strata czasu na przeszukiwanie',
              'Niepewność co do wyboru',
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-line text-secondary-600 text-sm"></i>
                </div>
                <span className="font-body text-foreground-700">{item}</span>
              </div>
            ))}
          </div>

          <div className="text-left space-y-5">
            <p className="font-heading text-xl font-semibold text-accent-600 mb-4">Z Kakobuy Spreadsheet:</p>
            {[
              'Wszystkie produkty w jednym miejscu',
              'Kategorie produktów uporządkowane',
              'Szybkie wyszukiwanie i porównywanie',
              'Lepsze decyzje zakupowe bez stresu',
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-accent-600 text-sm"></i>
                </div>
                <span className="font-body text-foreground-700">{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { step: '1', icon: 'ri-search-line', title: 'Znajdź produkt', desc: 'Przeglądaj kategorie i znajdź idealny produkt dla siebie' },
            { step: '2', icon: 'ri-file-search-line', title: 'Sprawdź informacje', desc: 'Porównaj ceny, jakość i opinie innych użytkowników' },
            { step: '3', icon: 'ri-shopping-bag-3-line', title: 'Wybierz najlepszą opcję', desc: 'Podejmij świadomą decyzję i ciesz się zakupami' },
          ].map((item, i) => (
            <div key={i} className="relative p-6 rounded-2xl bg-background-50 text-center group hover:bg-accent-50/30 transition-colors duration-300">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <span className="font-label text-sm font-bold text-accent-600">{item.step}</span>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="font-body text-sm text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}